export default {
  locale: (state) => state.locale,
  availableTranslations: (state) => state.availableTranslations,
};
